import intl from 'react-intl-universal';
import EmptyLDTTeamMembers from 'assets/images/empty-ld-team-members.svg';
import { Typography } from '@getsynapse/design-system';

const EmptyMembersTableBody = () => {
  return (
    <tbody>
      <tr>
        <td colSpan={6}>
          <div className='flex flex-col gap-2 items-center justify-center h-61 py-8'>
            <img src={EmptyLDTTeamMembers} alt='Empty LD Team Members' />
            <Typography variant='body'>
              {intl.get(
                'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.MEMBERS_TABLE.EMPTY_TABLE'
              )}
            </Typography>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default EmptyMembersTableBody;
